<template>
  <div class="firmware-container">
    <div class="search-layout">
      <el-form :model="queryInfo" size="medium" :inline="true">
          <el-form-item :label="$t('finance.name39')" prop="tenantId" v-if="userinfo.tenantType === 0">
              <el-cascader ref="refHandle" v-model="tenantIds" :placeholder="$t('public.name1')" :show-all-levels="false" @change="handleChange" :props="{ lazy: true, lazyLoad: loadOptions, checkStrictly: true }" clearable></el-cascader>
          </el-form-item>
          <el-form-item :label="$t('bike.name30')" prop="tenantId" v-if="userinfo.tenantType === 1">
            <el-select v-model="queryInfo.tenantId" :placeholder="$t('public.name1')">
              <el-option v-for="item in tenantOptions" :key="item.tenantId" :label="item.tenantName" :value="item.tenantId"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('finance.name33')" prop="ebikeId">
            <el-input v-model="queryInfo.ebikeId" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item>
          <el-form-item :label="$t('bike.name18')" prop="fileName">
            <el-input v-model="queryInfo.fileName" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item>
          <el-form-item :label="$t('bike.name59')" prop="hardwareType">
            <el-select :key="'firmware-type-' + $i18n.locale" v-model="queryInfo.hardwareType" :placeholder="$t('public.name1')" clearable>
              <el-option v-for="item in firmwareTypeOptions" :key="item.name" :label="item.label" :value="item.name"> </el-option>
            </el-select>
          </el-form-item>
        <el-form-item >
          <div class="bt-layout">
        <el-button type="primary" size="medium" @click="getPageList">{{$t('public.name3')}}</el-button>
        <el-button size="medium" @click="resetQuery">{{$t('public.name4')}}</el-button>
      </div>
          </el-form-item>
      </el-form>
    </div>
    <el-table :data="tableList" :header-cell-style="{ fontSize: '14px', backgroundColor: '#f5f5f5', color: '#555' }" v-loading="tableLoading">
      <el-table-column :label="$t('bike.name38')" prop="ebikeId" sortable></el-table-column>
      <el-table-column :label="$t('finance.name40')" prop="tenantName" sortable v-if="userinfo.tenantType === 0">
        <template slot-scope="scope">
          <div v-if="scope.row.parentId">{{ scope.row.parentName }} > {{ scope.row.tenantName }}</div>
          <div v-else>{{ scope.row.tenantName }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('bike.name105')" prop="tenantName" sortable v-if="userinfo.tenantType === 1"></el-table-column>
      <el-table-column :label="$t('bike.name60')" prop="upgradeState" sortable>
        <template slot-scope="scope">
          <div>{{ ['',$t('bike.name411'),$t('bike.name412'),$t('tabmenu.name55')][scope.row.upgradeType] }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('bike.name61')" prop="hardwareType" sortable>
        <template slot-scope="scope">
          <div>{{ ['IOT',$t('bike.name14'),$t('bike.name413')][scope.row.hardwareType] }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('bike.name25')" prop="fileName" sortable></el-table-column>
      <el-table-column :label="$t('bike.name63')" prop="upgradeState" sortable>
        <template slot-scope="scope">
          <div v-if="scope.row.upgradeState === -1">{{ $t('bike.name414') }}</div>
          <div v-else>{{ [ $t('bike.name415'), $t('bike.name416'), $t('bike.name417'), $t('bike.name418'), $t('bike.name419')][scope.row.upgradeState] }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('bike.name64')" prop="createTime" sortable>
        <template slot-scope="scope">
          {{ scope.row.createTime | tzDisplay }}
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryInfo.pageNumber"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="queryInfo.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
  </div>
</template>
<script>
import { findUpgradePage } from '@/api/bike.js'
import { tenantList } from '@/api/manage.js'
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['userinfo']),
    firmwareTypeOptions () {
      return [
        { name: 0, label: 'IOT' },
        { name: 1, label: this.$t('bike.name14') },
        { name: 2, label: this.$t('bike.name413') }
      ]
    }
  },
  data() {
    return {
      tenantIds: [],
      tableLoading: false,
      tenantOptions: [],
      tableList: [],
      queryInfo: {
        pageNumber: 1,
        pageSize: 10,
        ebikeId: '',
        tenantId: '',
        hardwareType: '',
        fileName: ''
      },
      total: 0,
      hasQueried: false,
      otalist: [],
      timer: null
    }
  },
  created() {
    this.getTenantList()
    this.queryList()
  },
  mounted() {
    // 固件升级状态需跟踪：仅用户主动查询后才每 30s 刷新，避免空载或宽条件下反复全量拉取
    this.timer = setInterval(() => {
      if (this.hasQueried) {
        this.queryList()
      }
    }, 30000)
  },
  beforeDestroy() {
    clearInterval(this.timer)
    this.timer = null
  },
  methods: {
    getPageList() {
      this.queryInfo.pageNumber = 1
      this.queryInfo.pageSize = 10
      this.queryList()
    },
    buildFirmwareListParams(pageNumber, pageSize) {
      return {
        ...this.queryInfo,
        pageNumber,
        pageSize,
        fileName: (this.queryInfo.fileName || '').trim(),
        ebikeId: this.queryInfo.ebikeId ? this.queryInfo.ebikeId.trim() : ''
      }
    },
    async queryList() {
      this.hasQueried = true
      this.tableLoading = true
      try {
        const params = this.buildFirmwareListParams(this.queryInfo.pageNumber, this.queryInfo.pageSize)
        const res = await findUpgradePage(params)
        if (res && res.code === 200) {
          this.tableList = (res.data && res.data.upgradePage && res.data.upgradePage.records) || []
          this.total = (res.data && res.data.upgradePage && res.data.upgradePage.total) || 0
        } else {
          this.tableList = []
          this.total = 0
        }
      } catch (e) {
        this.tableList = []
        this.total = 0
      } finally {
        this.tableLoading = false
      }
    },
    getListData() {
      return this.queryList()
    },
    resetQuery() {
      this.queryInfo = {
        pageNumber: 1,
        pageSize: 10,
        ebikeId: '',
        tenantId: '',
        hardwareType: '',
        fileName: ''
      }
      this.tenantIds = []
      this.hasQueried = true
      this.queryList()
    },
    loadOptions(node, resolve) {
      if (node.level === 2) {
        resolve([])
        return
      }
      let data = {
        page: 1,
        limit: 500,
        tenantType: 1
      }

      if (node.level === 1) {
        data = {
          page: 1,
          limit: 500,
          tenantType: 2,
          parentId: node.value
        }
      }

      tenantList(data)
        .then(res => {
          if (res.data.list) {
            const options = res.data.list.map(item => ({
              value: item.tenantId,
              label: item.tenantName,
              leaf: node.level >= 1
            }))
            resolve(options)
          } else {
            resolve([])
          }
        })
        .catch(() => {})
    },
    getTenantList() {
      const data = {
        page: 1,
        limit: 500,
        tenantType: 2
      }
      tenantList(data)
        .then((res) => {
          if (res.code === 200) {
            this.tenantOptions = res.data.list
          }
        })
        .catch(() => {})
    },
    handleChange(value) {
      // 处理选项变化
      this.queryInfo.tenantId = value[value.length - 1]
      const panelRefs = this.$refs.refHandle.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.activePath.forEach(item => {
          if (item.children.length === 0) {
            panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
          }
        })
      }
      // this.getListData()
    },
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize
      this.queryInfo.pageNumber = 1
      this.queryList()
    },
    handleCurrentChange(newPage) {
      this.queryInfo.pageNumber = newPage
      this.queryList()
    }
  }
}
</script>
<style lang="scss" scoped>
.firmware-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  .search-layout {
    width: 100%;
    display: flex;
    justify-content: space-between;
    .bt-layout {
      display: flex;
      flex-direction: row;
      height: 36px;
      margin-left: 30px;
    }
  }
}
</style>
